<template>
    <div>
        <Header/>
        <div class="zwB "></div>
        <div class="bodyBG2">
            <div class="curBoxb">
              <BreadCrumb/>
            </div>
            <div class="zcglBa"></div>
            <div class="listPBa">
              <CompanyIntroductionsLeftNav/>
                <div class="listPBr">
                  <div class="docTitleB">
                    <h1>
                      {{$t('company_culture')}}
                    </h1>
                    <div class="timeB">
                      {{$t('belonging_to')}} {{$t('company_introductions')}} {{$t('author')}} {{$t('tajik_securities')}} {{$t('update_time')}}：2020-06-03 14:03:36
                    </div>
                  </div>
                    <div class="docHtmlB">
                      <div class="TRS_Editor">
                        <div>
                          <ul>
                            <li>
                              <b style="font-weight: bold;font-size: 16px;line-height: 220%" >{{$t('company_culture_introduction_1_title')}}</b>
                              <p>{{$t('company_culture_introduction_1_descripte')}}</p>
                            </li>
                            <li>
                              <b style="font-weight: bold;font-size: 16px;line-height: 220%" >{{$t('company_culture_introduction_2_title')}}</b>
                              <p>{{$t('company_culture_introduction_2_descripte')}}。</p>
                            </li>
                            <li>
                              <b style="font-weight: bold;font-size: 16px;line-height: 220%" >{{$t('company_culture_introduction_3_title')}}</b>
                              <p>{{$t('company_culture_introduction_3_descripte_one')}}</p>
                              <p>{{$t('company_culture_introduction_3_descripte_two')}}</p>
                              <p>{{$t('company_culture_introduction_3_descripte_three')}}</p>
                              <p>{{$t('company_culture_introduction_3_descripte_four')}}</p>
                            </li>
                            <li>
                              <b style="font-weight: bold;font-size: 16px;line-height: 220%" >{{$t('company_culture_introduction_4_title')}}</b>
                              <p>{{$t('company_culture_introduction_4_descripte_one')}}</p>
                              <p>{{$t('company_culture_introduction_4_descripte_two')}}</p>
                              <p>{{$t('company_culture_introduction_4_descripte_three')}}</p>
                              <p>{{$t('company_culture_introduction_4_descripte_four')}}</p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
</template>
<script>
  import Footer from "../components/Footer";
  import Header from "../components/Header";
  import CompanyIntroductionsLeftNav from "../components/CompanyIntroductionsLeftNav";
  import BreadCrumb from "../components/BreadCrumb";

  export default {
    components: {BreadCrumb, CompanyIntroductionsLeftNav, Footer, Header}
  }
</script>
<style lang="scss" scoped>
@import url('../css/2020_swiper.min.css');
@import url('../css/public_20200313v4.css');
@import url('../css/index.css');
@import url('../css/public_footer.css');
@import url('../css/zxStyle.css');
@import url('../css/zxPubliceStyle.css');
@import url('../css/shzr_zr2020.css');
</style>
<style >
  .zwB {
    height: 110px;
  }
  .TRS_Editor li{
    margin-bottom: 20px;
  }
  .TRS_Editor p{
    padding: 0px;
    text-indent: 2em;
  }
  .TRS_Editor b{
    margin-bottom: 10px;
  }
</style>